import { render } from "./SectionLoader.vue?vue&type=template&id=104bbed0&scoped=true"
import script from "./SectionLoader.vue?vue&type=script&lang=js"
export * from "./SectionLoader.vue?vue&type=script&lang=js"

import "./SectionLoader.vue?vue&type=style&index=0&id=104bbed0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104bbed0"],['__file',"src/scripts/view/portfolio/sections/SectionLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "104bbed0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('104bbed0', __exports__)) {
    api.reload('104bbed0', __exports__)
  }
  
  module.hot.accept("./SectionLoader.vue?vue&type=template&id=104bbed0&scoped=true", () => {
    api.rerender('104bbed0', render)
  })

}


export default __exports__